export const singleton = (type) => {
  type.isSingleton = true;

  return type;
}
